"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _client = require("@apollo/client");
var _propTypes = require("prop-types");
var _dsWeb = require("@olxbr/ds-web");
var _ResultBox = _interopRequireDefault(require("../ResultBox"));
var _platform = require("../../../../helpers/platform");
var _selectors = require("../../../../selectors");
var _actions = require("../../../../actions");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var DeleteBox = function DeleteBox(_ref) {
  var initialAdSubject = _ref.adSubject,
    initialPartnerName = _ref.partnerName,
    roomname = _ref.roomname,
    closeModalAction = _ref.closeModalAction,
    deleteCurrentChatAction = _ref.deleteCurrentChatAction;
  var _useState = (0, _react.useState)(initialAdSubject),
    _useState2 = _slicedToArray(_useState, 2),
    adSubject = _useState2[0],
    setAdSubject = _useState2[1];
  var _useState3 = (0, _react.useState)(initialPartnerName),
    _useState4 = _slicedToArray(_useState3, 2),
    partnerName = _useState4[0],
    setPartnerName = _useState4[1];
  var DELETE_CHAT = (0, _client.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation UpdateChat {\n      updateChat(roomname: \"", "\", delete: true) {\n          success\n      }\n    }\n  "])), roomname);
  var _useMutation = (0, _client.useMutation)(DELETE_CHAT),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    mutationDeleteChat = _useMutation2[0];
  (0, _react.useEffect)(function () {
    setAdSubject(initialAdSubject);
    setPartnerName(initialPartnerName);
  }, [initialAdSubject, initialPartnerName]);
  var handleClose = function handleClose() {
    closeModalAction();
  };
  var handleDelete = function handleDelete() {
    return mutationDeleteChat().then(function (_ref2) {
      var _data$updateChat;
      var data = _ref2.data;
      if (data !== null && data !== void 0 && (_data$updateChat = data.updateChat) !== null && _data$updateChat !== void 0 && _data$updateChat.success) {
        deleteCurrentChatAction(errorModalRender);
      } else {
        deleteCurrentChatAction(errorModalRender);
        new Error('Error: No data returned from mutation.');
      }
    })["catch"](function (error) {
      deleteCurrentChatAction(errorModalRender);
      console.error('Error deleting chat', error);
    });
  };
  var errorModalRender = function errorModalRender() {
    var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UNKNOWN';
    var title = reason === 'NO_INTERNET' ? 'Você está sem Internet' : 'Não foi possível excluir o chat';
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResultBox["default"], {
      title: title,
      onPress: closeModalAction,
      children: "Espere um momento e tente novamente mais tarde."
    });
  };
  var customMessage = "Excluir chat com \"".concat(partnerName, "\" sobre \"").concat(adSubject, "\"?");
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.TitleWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.TitleMedium, {
        children: "Excluir Chat"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.BodyMedium, {
      children: customMessage
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ButtonsWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        onClick: handleClose,
        variant: "link-button",
        fullWidth: _platform.isMsite,
        children: "Cancelar"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        onClick: handleDelete,
        fullWidth: _platform.isMsite,
        children: "Excluir"
      })]
    })]
  });
};
DeleteBox.propTypes = {
  adSubject: _propTypes.string,
  closeModalAction: _propTypes.func.isRequired,
  deleteCurrentChatAction: _propTypes.func.isRequired,
  partnerName: _propTypes.string
};
DeleteBox.defaultProps = {
  adSubject: '',
  partnerName: ''
};
var mapStateToProps = function mapStateToProps(state) {
  var _getCurrentPartner = (0, _selectors.getCurrentPartner)(state),
    partnerName = _getCurrentPartner.name;
  var _getCurrentChat = (0, _selectors.getCurrentChat)(state),
    adSubject = _getCurrentChat.subject;
  var roomname = (0, _selectors.getCurrentRoomname)(state);
  return {
    adSubject: adSubject,
    partnerName: partnerName,
    roomname: roomname
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    closeModalAction: _actions.closeModal,
    deleteCurrentChatAction: _actions.deleteCurrentChat
  }, dispatch);
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps, mapDispatchToProps)(DeleteBox);